/*
 * @Desc: 题目配置 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-22 09:39:34
 */
import request from "@/utils/request";
const index = {
    // 列表
    list(query) {
        return request({
            url: "/survey/list",
            method: "get",
            params: query
        });
    },
    // 问卷模板下拉选
    select(query) {
        return request({
            url: "/wenjuan/select",
            method: "get",
            params: query
        });
    },
    // 新增
    create(data) {
        return request({
            url: "/survey/create",
            method: "post",
            data
        });
    },
    // 编辑
    edit(data) {
        return request({
            url: "/survey/edit",
            method: "post",
            data
        });
    },
    // 状态
    status(data) {
        return request({
            url: "/survey/status",
            method: "post",
            data
        });
    },
    // 删除
    remove(data) {
        return request({
            url: "/survey/remove",
            method: "post",
            data
        });
    },
    // 详情
    detail(data) {
        return request({
            url: "/survey/detail",
            method: "post",
            data
        });
    },
    shareUrl(query) {
        return request({
            url: "/survey/shareUrl",
            method: "get",
            params: query
        });
    },
};
export default index;
